import { graphql } from "@acto/gql";
import { useQuery } from "urql";
import type { TeamLineThresholds } from "@acto/taskpane/core/domain";

const TeamLineThresholdsQuery = graphql(`
  query GetTeamLineThresholds {
    tenantSettings {
      teamLineThresholds {
        noReportMinCount
        noReportMinShare
        didNotTakePlaceMinCount
        didNotTakePlaceMinShare
      }
    }
  }
`);

/** Null until loaded, when the api has none, or when the request fails. */
export function useTeamLineThresholds(): TeamLineThresholds | null {
  const [{ data }] = useQuery({ query: TeamLineThresholdsQuery, requestPolicy: "cache-first" });

  const thresholds = data?.tenantSettings.teamLineThresholds;
  return thresholds
    ? {
        noReportMinCount: thresholds.noReportMinCount,
        noReportMinShare: thresholds.noReportMinShare,
        didNotTakePlaceMinCount: thresholds.didNotTakePlaceMinCount,
        didNotTakePlaceMinShare: thresholds.didNotTakePlaceMinShare,
      }
    : null;
}
